// extracted by mini-css-extract-plugin
module.exports = {"talkCard":"Talks_talkCard__1gOzQ","img":"Talks_img__29C5T","title":"Talks_title__1nElE","list":"Talks_list__1B6XK"};